import * as React from 'react';
import { paramCase } from "change-case";
import { safe, toCode, isNullOrUndefined, isShareDisabled, addItemToGoogleTracking, getViewFundList } from "../../utils";
import { IPageProperties, IWatchlist } from "../../models";

const FaClose = require('react-icons/lib/fa/times-circle');
const FaAngelRight = require('react-icons/lib/fa/angle-right');
const styles = require('./styles.pcss');

const FaPlus = require('react-icons/lib/fa/plus');
const FaMinus = require('react-icons/lib/fa/minus');
const FaStarO = require('react-icons/lib/fa/star-o');
const FaStar = require('react-icons/lib/fa/star');

interface IProps {
    isFundPage?: boolean;
    isMobile?: boolean;
}

interface IState {
    visible?: boolean;
    added?: boolean;
    width?: number;
}

export class Watchlist extends React.Component<IPageProperties & IProps, IState>{

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            added: true
        };
        this.toggle = this.toggle.bind(this);
        this.removeWishlistItem = this.removeWishlistItem.bind(this);
    }

    updateLocalState() {
        this.setState({ width: window.innerWidth });
    }

    componentWillMount() {
        this.updateLocalState();
    }

    removeWishlistItem(watchlistItems: IWatchlist, event) {
        let { appParams } = this.props;
        this.props.editWatchlist(watchlistItems, appParams, true);
    }

    toggle() {
        let { appParams } = this.props;
        let visible = !this.state.visible;
        addItemToGoogleTracking(appParams, "watchlist", { eventCategory: "watchlistToggle", eventLabel: visible ? 'open' : 'close' });
        this.setState({ visible });
    }

    getList(watchlist: IWatchlist[], internalClasses) {
        let { appParams, isMobile } = this.props;
        let subWatchlist = watchlist.filter(item => item.fundList === getViewFundList(appParams));
        if (subWatchlist.length > 0) {
            return subWatchlist.map((watchListItem, index) => {
                let fundName = paramCase(watchListItem.fundName);
                return (
                    <li key={ `${ watchListItem.fundIdentifier }-${ watchListItem.isin }` } className={ internalClasses.addedItem }>
                        <div onClick={ e => this.removeWishlistItem(watchListItem, e) } className={ styles.closeBtn }><FaClose /></div>
                        <div className={ styles.watchListItem }>
                            { (() => {
                                if (isShareDisabled(watchListItem.isin) || appParams.productrange.toLowerCase() === "ppl") {
                                    return <h4>{ watchListItem.isin }</h4>;
                                } else {
                                    return <h4><a href={ `${ appParams.baseurl }funds/${ fundName }/${ watchListItem.isin.toLowerCase() }/` }>{ watchListItem.isin }</a></h4>;
                                }
                            })() }
                            <span>{ watchListItem.fundName }</span>
                        </div>
                    </li>
                )
            });
        }
        else {
            return (
                <li className={ styles.noItems }>
                    <em>
                        Your watchlist is empty.<br />
                        Please add funds from the fund explorer <a href={ `${ appParams.baseurl }${ appParams.fundExplorerUrl }` }>here</a>.
                    </em>
                </li>
            );
        }
    }

    viewWatchlist() {
        event.preventDefault();
        let { appParams, watchlist } = this.props;
        let options;

        if (watchlist.length > 0) {
            options = [{
                property: "isin",
                matchtype: "MATCH",
                values: watchlist.map(item => item.isin)
            }];

            this.props.changeFilter({ search: options }, appParams);
            this.toggle();
        }
    }

    render() {
        let { isLoading, watchlist, shareClass, fund, appParams } = this.props;
        let visibility = !this.state.visible ? '' : styles.active;
        let removeItem = !this.state.added ? styles.remove : '';
        let isPrivateInvestor = appParams.clienttype === "pri";

        let internalClasses = {
            dropdown: `${ styles.watchListBoard } ${ visibility }`,
            addedItem: `${ styles.listGroupItem } ${ removeItem }`

        }

        return (
            <div className={ styles.wrapper }>
                <div className={ styles.watchlistPanel }>
                    <button type="button" onClick={ this.toggle } className={ styles.btnNotice }>
                        Watchlist <span className={ styles.notificationNumber }>{ watchlist.filter(item => item.fundList === getViewFundList(appParams)).length }</span>
                    </button>
                    <div className={ internalClasses.dropdown }>
                        <h3 className={ styles.title }>YOUR WATCHLIST
                            {/* <span>{watchlist.length}</span>*/ }
                            <div className={ styles.closeBtn } onClick={ this.toggle }><span>CLOSE  { '  ' } &#10005;</span></div>
                        </h3>

                        <div className={ styles.watchListContent }>
                            <div className={ styles.tabPane }>
                                <ul className={ styles.noticeList }>
                                    { this.getList(watchlist, internalClasses) }
                                </ul>
                            </div>
                        </div>
                        { (() => {
                            if (watchlist.filter(item => item.fundList === getViewFundList(appParams)).length > 0) {
                                return (
                                    <a onClick={ () => addItemToGoogleTracking(appParams, "watchlist", { eventCategory: "watchlistView", eventLabel: 'view all' }) }
                                        href={ `${ appParams.baseurl }${ appParams.fundExplorerUrl }?isins=${ watchlist.filter(item => item.fundList === getViewFundList(appParams)).map(item => item.isin).join(",") }` }
                                        className={ styles.btnMore }>
                                        VIEW ALL WATCHLIST ITEMS
                                        <FaAngelRight />
                                    </a>
                                );
                            }
                        })() }
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/client/components/Watchlist/index.tsx